const PARAMS_MAP = {
  soft: {
    scale: 1.2,
    ease: 'cubicInOut'
  },
  medium: {
    scale: 1.6,
    ease: 'quintInOut'
  },
  hard: {
    scale: 2,
    ease: 'backOut'
  }
};
export default function create(options) {
  const {
    power,
    initialScale = PARAMS_MAP.medium.scale
  } = options.namedEffect;
  const scale = power && PARAMS_MAP[power].scale || initialScale;
  const easing = power && PARAMS_MAP[power].ease || options.easing || 'quintInOut';
  return [{
    ...options,
    easing: 'quadOut',
    duration: options.duration * 0.8,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    easing,
    keyframes: [{
      scale: `${scale}`
    }, {
      scale: '1'
    }]
  }];

  /*
   * @keyframes <name>-fade{
   *   from {
   *     opacity: 0;
   *   }
   *   to {
   *     opacity: 1;
   *   }
   * }
   *
   * * @keyframes <name>-scale {
   *   from {
   *     scale: <scale>
   *   }
   *   to {
   *     scale: 1
   *   }
   * }
   *
   *
   * #target {
   *   animation: <name>-scale <duration> <delay> <easing> backwards;
   *              <name>-fade <duration  * 0.8> <delay> quadOut backwards;
   * }
   */
}
//# sourceMappingURL=DropIn.js.map